import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, clearToken } from "../lib/api";

export function Layout() {
  const nav = useNavigate();
  const meQ = useQuery({ queryKey: ["me"], queryFn: api.me });

  function logout() {
    clearToken();
    nav("/login");
  }

  return (
    <div className="layout">
      <aside className="sidebar">
        <h1>CRM Real Mind</h1>

        <div className="sec">Работа</div>
        <NavLink to="/" end>Воронка</NavLink>
        <NavLink to="/tasks">Задачи</NavLink>

        <div className="sec">Цифры</div>
        <NavLink to="/analytics">Аналитика</NavLink>

        <div className="side-foot">
          <div className="who">{meQ.data?.full_name || meQ.data?.tg_username || "..."}</div>
          <div className="role">{meQ.data?.role}</div>
          <button onClick={logout}>Выйти</button>
        </div>
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
